module.exports = __webpack_public_path__ + "9e126d2f93cfdcbda9740b0be0e8b2da.winter.svg";